import { render, staticRenderFns } from "./ExcelUpload.vue?vue&type=template&id=22001c7c&scoped=true"
import script from "./ExcelUpload.vue?vue&type=script&lang=js"
export * from "./ExcelUpload.vue?vue&type=script&lang=js"
import style0 from "./ExcelUpload.vue?vue&type=style&index=0&id=22001c7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22001c7c",
  null
  
)

export default component.exports